import { render } from "./eventCalendar.vue?vue&type=template&id=513b327f&scoped=true"
import script from "./eventCalendar.vue?vue&type=script&lang=js"
export * from "./eventCalendar.vue?vue&type=script&lang=js"

import "./eventCalendar.vue?vue&type=style&index=0&id=513b327f&lang=scss&scoped=true"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513b327f"]])

export default __exports__